var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-location-filter"
  }, [_c('span', {
    staticClass: "cm-location-filter__location-icon"
  }, [_vm._v("location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "cm-location-filter__input",
    attrs: {
      "type": "text",
      "placeholder": "Location",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cm-location-filter__separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "cm-location-filter__radius"
  }, [_c('select', {
    staticClass: "cm-location-filter__radius-select",
    domProps: {
      "value": _vm.radius
    },
    on: {
      "input": function($event) {
        _vm.$emit('radius', $event.target.value)
      }
    }
  }, _vm._l((_vm.miles), function(mile) {
    return _c('option', {
      key: mile,
      domProps: {
        "value": (mile + " miles")
      }
    }, [_vm._v(_vm._s((mile + " miles")))])
  })), _vm._v(" "), _c('div', {
    staticClass: "cm-location-filter__radius-arrow"
  }, [_vm._v("navigatedown")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2106b028","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/location-filter.vue
// module id = null
// module chunks = 